document.addEventListener('DOMContentLoaded', () => {
  // Calculator logic
  const calculator = document.querySelector('.calculator_div_new');
  if (calculator) {
    const elements = {
      areaInput: document.getElementById('sqmnumber'),
      piecesEl: document.querySelector('.pieces-txt-val'),
      coverageEl: document.querySelector('.pieces-txt-val1'),
      wastageCheckbox: document.getElementById('customwaste_wastageToggle'),
      resultsContainer: document.querySelector('.description_div'),
      priceEl: document.querySelector('.price__number'),
      areaSpan: document.querySelector('#areaCovered'),
      quantityInput: document.querySelector('input[name="quantity"]'),
      displayBox: document.querySelector('.total-boxes-output'),
      increaseBtn: document.getElementById('increase-btn'),
      decreaseBtn: document.getElementById('decrease-btn'),
    };

    const recalculateQuantity = () => {
      if (!elements.areaInput) return;

      
      const areaValue = parseFloat(elements.areaInput.value || 0);
      const piecesPerBox = parseInt(elements.piecesEl?.textContent.replace(/\D/g, '') || 0);
      const boxCoverage = parseFloat(elements.coverageEl?.textContent.replace(/[^\d.]/g, '') || 0);
      const includeWastage = elements.wastageCheckbox?.checked || false;

      const adjustedInput = includeWastage ? areaValue * 1.15 : areaValue;
      const totalQty = boxCoverage > 0 ? Math.ceil(adjustedInput / boxCoverage) : Math.ceil(adjustedInput);
      const adjustedArea = boxCoverage > 0 ? totalQty * boxCoverage : adjustedInput;

      if (elements.quantityInput) {
        elements.quantityInput.value = totalQty;
      }

      if (elements.displayBox) {
        elements.displayBox.textContent = totalQty ? `${totalQty} Boxes` : '';
      }

      if (elements.areaSpan) {
        elements.areaSpan.value = adjustedArea.toFixed(2);
      }

      const price = parseFloat(elements.priceEl?.textContent.replace(/[^0-9.]/g, '') || 0);
      const totalCost = (totalQty * price).toFixed(2);

      if (elements.resultsContainer && boxCoverage > 0) {
        elements.resultsContainer.innerHTML = `
          1 box covers <span class="highlighted">${boxCoverage.toFixed(2)}</span> sqm<br>
          You entered <span class="highlighted">${areaValue}</span> sqm${includeWastage ? `, with 15% wastage = <span class="highlighted">${adjustedInput.toFixed(2)}</span> sqm` : ''}<br>
          Rounded to nearest multiple: <span class="highlighted">${adjustedArea.toFixed(2)}</span> sqm<br>
          Required boxes = <span class="highlighted">${adjustedArea.toFixed(2)}</span> / <span class="highlighted">${boxCoverage.toFixed(2)}</span> = <span class="highlighted">${totalQty}</span><br>
          Cost = <span class="highlighted">${totalQty}</span> × $<span class="highlighted">${price.toFixed(2)}</span> = <span class="highlighted">${totalCost}</span>
        `;
      }
    };

    document.querySelectorAll('.product-form__swatch__item').forEach(el => el.removeAttribute('checked'));
    document.querySelectorAll('.product-form__swatch__input').forEach(input => {
      if (input.hasAttribute('checked') || input.checked) {
        input.closest('.product-form__swatch__item')?.setAttribute('checked', 'true');
        recalculateQuantity();
      }
    });

    elements.areaInput?.addEventListener('input', recalculateQuantity);
    elements.increaseBtn?.addEventListener('click', () => {
      elements.areaInput.value = (parseFloat(elements.areaInput.value || 0) + 1).toFixed(2);
      recalculateQuantity();
    });
    elements.decreaseBtn?.addEventListener('click', () => {
      elements.areaInput.value = Math.max(0.01, parseFloat(elements.areaInput.value || 0) - 1).toFixed(2);
      recalculateQuantity();
    });
    elements.wastageCheckbox?.addEventListener('change', recalculateQuantity);

    document.querySelectorAll('.product-form__swatch__item').forEach(item => {
      item.addEventListener('click', function () {
        document.querySelectorAll('.product-form__swatch__item').forEach(el => el.removeAttribute('checked'));
        item.setAttribute('checked', 'true');
        recalculateQuantity();
      });
    });

    if (elements.piecesEl) {
      const observer = new MutationObserver(recalculateQuantity);
      observer.observe(elements.piecesEl, { childList: true, subtree: true });
    }

    if (elements.coverageEl) {
      const observer = new MutationObserver(recalculateQuantity);
      observer.observe(elements.coverageEl, { childList: true, subtree: true });
    }
  }

  // Wastage toggle UI
  const toggleWastageCheckbox = document.getElementById('customwaste_wastageToggle');
  const nextSpan = document.querySelector('.customwaste_slider');
  if (toggleWastageCheckbox && nextSpan) {
    toggleWastageCheckbox.addEventListener('change', () => {
      if (toggleWastageCheckbox.checked) {
        toggleWastageCheckbox.classList.add('active-toggle');
        nextSpan.classList.add('active-toggle-span');
        toggleWastageCheckbox.classList.remove('inactive-toggle');
        nextSpan.classList.remove('inactive-toggle-span');
      } else {
        toggleWastageCheckbox.classList.add('inactive-toggle');
        nextSpan.classList.add('inactive-toggle-span');
        toggleWastageCheckbox.classList.remove('active-toggle');
        nextSpan.classList.remove('active-toggle-span');

        if (!sessionStorage.getItem('wastageModalShown')) {
          const wastageInfoModal = document.getElementById('customwaste_wastageModal');
          if (wastageInfoModal) {
            wastageInfoModal.style.display = 'block';
            document.body.classList.add('modal-open');
          }
        }
      }
    });
  }

  // Wastage modal close logic
  const closeButton = document.querySelector('.customwaste_close');
  const closeButton2 = document.querySelector('.customwaste_no-btn');
  const keepButton = document.querySelector('.customwaste_keep-btn');
  const modal = document.getElementById('customwaste_wastageModal');

  function closeModal() {
    if (!modal) return;
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (closeButton2) {
    closeButton2.addEventListener('click', closeModal);
  }

  if (keepButton) {
    keepButton.addEventListener('click', function () {
      closeModal();
      document.getElementById('customwaste_wastageToggle').click();
    });
  }

  // Move element logic
  const target = document.querySelector(".product-single__box__block--buy_buttons");
  const elementToMove = document.querySelector(".move_class_in_product");
  if (target && elementToMove) {
    target.insertBefore(elementToMove, target.firstChild);
  }
});


